@if (errorMessage(); as message) {
    <div class="feedback feedback-invalid">
        <p class="msg">{{ message }}</p>
    </div>
}
